// import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, NgZone, AfterViewInit, ViewChild, ElementRef, Renderer2, SimpleChanges, OnChanges } from '@angular/core';
// import { Platform } from '@ionic/angular';
// import * as moment from 'moment';

// // Define the interface for your API response data
// interface TimeSlotGroup {
//   key: string;
//   value: string[]; // e.g., ["10:00 AM", "10:15 AM"]
// }

// interface ApiResponse {
//   success: boolean;
//   code: number;
//   message: string;
//   data: {
//     timeslots: TimeSlotGroup[];
//   };
// }

// // New interface for enriched day data including buffer properties
// interface DayData {
//   moment: moment.Moment;
//   daydate: string; // e.g., '25'
//   dayOfWeekShort: string; // e.g., 'Mon'
//   dayOfWeekFull: string; // e.g., 'Monday'
//   showday: boolean; // Is it part of the actual month, or a filler?
//   selected: boolean; // Is this day currently selected?
//   isToday: boolean; // Is this day today's date?
//   isBuffer?: boolean; // New: Is this an empty buffer day for scrolling?
// }
// interface EditTime {
//   active: boolean;
//   input?: string;
//   formatted?: string;
//   digits?: string[]; // Add this property, assuming it's an array of strings
// }
// @Component({
//   selector: 'test-item',
//   templateUrl: './test-item.component.html',
//   styleUrls: ['./test-item.component.scss'],
// })
// export class TestItemComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
//   edittime: EditTime = {
//     active: false,
//     input: '',
//     formatted: '',
//     digits: [] // Initialize it here as well
//   };
//   // --- @Inputs() ---
//   @Input('datepicker-title') datepickerTitle: string = 'Select Date';
//   @Input('custom-message') customMessage: string = 'You have selected';
//   // Initialize with current moment, will be overwritten by input if valid
//   @Input() selecteddate: moment.Moment = moment();
//   @Input('picktime') picktime: boolean = true;
//   @Input('pickdate') pickdate: boolean = true;
//   @Input('pickpast') pickpast: boolean = false;
//   @Input('mondayfirst') mondayfirst: boolean = false;
//   @Input() appLanguage: string = 'en';

//   // New Input for available slots data
//   @Input('available-time-slots-data') availableTimeSlotsData: ApiResponse | null = null;

//   // --- @Output() ---
//   @Output() updatefn = new EventEmitter<{ formattedDate: string, selectedSlot: string, selectedKey: string }>();
//   @Output() dateSelected = new EventEmitter<moment.Moment>();

//   // --- View Children ---
//   @ViewChild('currentTimeElement', { static: false }) currentTimeElementRef!: ElementRef<HTMLElement>;
//   @ViewChild('timeline', { static: false }) timelineElementRef!: ElementRef<HTMLElement>;
//   @ViewChild('dateScrollContainer', { static: false }) dateScrollContainer!: ElementRef<HTMLElement>; // Reference to the date slider scroll container

//   // --- Internal Component State ---
//   currentTimeKey: string = '';
//   monthNames: string[] = moment.months(); // Full month names
//   dayNamesFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']; // Full day names
//   dayNamesShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']; // Short day names for display

//   currentViewDate: moment.Moment; // The month currently displayed in the calendar header
//   localdate: moment.Moment; // The currently selected full date and time
//   selectedDay: string = ''; // Full day name of the selected date (e.g., 'Monday')

//   month: DayData[] = []; // Array of actual month days
//   monthWithBuffers: DayData[] = []; // Array including buffer days for the slider

//   compact: boolean = true; // For responsive layout adjustments

//   // Timepicker state
//   timeframe: 'am' | 'pm' = 'am'; // This will now be derived from currentTimeKey or localdate
//   time: string = '12:00'; // HH:mm format for internal tracking
//   // edittime: { active: boolean; input?: string; formatted?: string } = { active: false }; // For time input editing

//   // Time Slider properties
//   private timelineWidth: number = 0;
//   private readonly totalMinutesInDay = 24 * 60; // For time slider calculations
//   availableMinutes: number[] = []; // Parsed available time slots in minutes
//   availableKeys: string[] = []; // NEW: Stores unique keys from availableTimeSlotsData

//   // Global event listener cleanup
//   private mouseMoveListener: (() => void) | null = null;
//   private mouseUpListener: (() => void) | null = null;
//   private touchMoveListener: (() => void) | null = null;
//   private touchEndListener: (() => void) | null = null;

//   constructor(
//     private platform: Platform,
//     private ngZone: NgZone,
//     private renderer: Renderer2
//   ) {
//           // this.pickdate = false;
//     // Initialize moments in constructor for safer access in template/lifecycle hooks
//     this.localdate = moment();
//     this.currentViewDate = this.localdate.clone().startOf('month');
//   }

//     trackByIndex(index: number, item: any): number {
//     return index; // Return the index as the unique identifier
//   }

//   ngOnInit() {
//     // Convert string inputs to booleans (if they come as strings from parent)
//     this.picktime = String(this.picktime) === 'true';
//     this.pickdate = String(this.pickdate) === 'true';
//     this.pickpast = String(this.pickpast) === 'true';
//     this.mondayfirst = String(this.mondayfirst) === 'true';

//     // Ensure `localdate` is properly initialized from `selecteddate` input
//     if (this.selecteddate && moment.isMoment(this.selecteddate) && this.selecteddate.isValid()) {
//       this.localdate = this.selecteddate.clone();
//     } else {
//       this.localdate = moment(); // Fallback to current moment if input is invalid
//     }

//     // Parse available slots BEFORE initializing time and date,
//     // so snapping can happen correctly during initialization.
//     this.parseAvailableTimeSlots();
//     this.initializeDateTimeSelector();
//     this.currentTimeKey = this.determineTimeKey(this.localdate); // Set initial time key
//   }

//   ngOnChanges(changes: SimpleChanges): void {
//     // Handle changes to selecteddate input
//     if (changes['selecteddate']) {
//         const newMomentValue = changes['selecteddate'].currentValue;
//         let newDateMoment: moment.Moment;
//         if (moment.isMoment(newMomentValue) && newMomentValue.isValid()) {
//             newDateMoment = newMomentValue.clone();
//         } else if (typeof newMomentValue === 'string' && moment(newMomentValue).isValid()) {
//             newDateMoment = moment(newMomentValue);
//         } else {
//             console.warn('Invalid moment object or string received for selecteddate input (ngOnChanges):', newMomentValue);
//             newDateMoment = moment(); // Fallback
//         }

//         // Only update if the date or time has actually changed to prevent unnecessary re-renders/emissions
//         if (!this.localdate || !newDateMoment.isSame(this.localdate, 'minute')) {
//             this.localdate = newDateMoment;
//             this.currentViewDate = newDateMoment.clone().startOf('month'); // Ensure header matches
//             this.parseAvailableTimeSlots(); // Re-parse as slots might change per day
//             this.initializeDateTimeSelector(); // Re-build calendar/slider and re-snap time
//             this.updateTimelineVisualization();
//             this.currentTimeKey = this.determineTimeKey(this.localdate);
//             this.emitSelection(); // Emit the new state
//             // Use setTimeout to ensure DOM updates before scrolling
//             this.ngZone.runOutsideAngular(() => {
//                 setTimeout(() => this.scrollToSelectedDate(), 0);
//             });
//         }
//     }

//     // Handle changes to availableTimeSlotsData input
//     if (changes['availableTimeSlotsData'] && changes['availableTimeSlotsData'].currentValue !== changes['availableTimeSlotsData'].previousValue) {
//       this.availableTimeSlotsData = changes['availableTimeSlotsData'].currentValue; // Update internal property
//       this.parseAvailableTimeSlots(); // Re-parse when input changes
//       this.snapLocaldateToNearestAvailableSlot(); // Snap to new slots if data changes
//       this.updateTimelineVisualization();
//       this.currentTimeKey = this.determineTimeKey(this.localdate);
//       this.emitSelection(); // Emit the new state
//     }
//   }

//   ngAfterViewInit() {
//     this.checkWidth(); // Initial check for compact mode
//     this.platform.resize.subscribe(() => { // Listen for platform resize events
//       this.ngZone.run(() => {
//         this.checkWidth();
//         this.updateTimelineVisualization(); // Update timeline on resize
//       });
//     });

//     // Ensure initial parsing and snapping even if data comes via static input
//     // (This might be redundant if ngOnInit and ngOnChanges cover it, but safe)
//     if (this.availableTimeSlotsData && this.availableMinutes.length === 0) {
//       this.parseAvailableTimeSlots();
//       this.snapLocaldateToNearestAvailableSlot();
//     }

//     // Scroll to the selected date after the view is fully rendered
//     this.ngZone.runOutsideAngular(() => {
//       setTimeout(() => {
//         this.scrollToSelectedDate();
//       }, 0); // Use setTimeout to ensure DOM is ready
//     });
//   }

//   ngOnDestroy() {
//     this.removeGlobalListeners();
//   }

//   // --- Core Initialization and State Management ---

//   private emitSelection() {
//     const formattedDateString = this.localdate.format('YYYY-MM-DD');
//     const selectedSlotString = this.findMatchingTimeSlotString();
//     this.updatefn.emit({
//       formattedDate: formattedDateString,
//       selectedSlot: selectedSlotString,
//       selectedKey: this.currentTimeKey
//     });
//   }

//   initializeDateTimeSelector() {
//     // Rebuild the month array and add buffers
//     this.month = this.getDaysArrayByMonth(this.currentViewDate);
//     this.addBufferDays();
//     this.updateSelectedDateInMonth(); // Mark the currently selected date

//     // Update display properties and snap time
//     this.selectedDay = this.localdate.format('dddd'); // e.g., 'Monday'
//     this.time = this.formatTime(this.localdate);
//     this.timeframe = this.localdate.hours() >= 12 ? 'pm' : 'am'; // Keep for AM/PM styling
//     this.updateInputTime(); // Update time input display

//     // Call snapLocaldateToNearestAvailableSlot here after parseAvailableTimeSlots has run
//     this.snapLocaldateToNearestAvailableSlot();
//   }

//   // --- Date Picker (Slider) Methods ---

//   currentMonthName(): string {
//     return this.currentViewDate.format('MMMM');
//   }

//   // Generates DayData objects for the current month
//   private getDaysArrayByMonth(date: moment.Moment): DayData[] {
//     const numDaysInMonth = date.daysInMonth();
//     const monthArray: DayData[] = [];
//     const today = moment().startOf('day');

//     // Calculate the day of the week for the 1st of the month
//     const firstDayMoment = date.clone().startOf('month');
//     let firstDayOfMonthIndex = firstDayMoment.day();

//     // Adjust if week starts on Monday
//     if (this.mondayfirst) {
//         firstDayOfMonthIndex = (firstDayOfMonthIndex === 0) ? 6 : firstDayOfMonthIndex - 1;
//     }

//     // Add actual days of the month
//     for (let i = 1; i <= numDaysInMonth; i++) {
//       const dayMoment = date.clone().date(i).startOf('day');
//       const isSelected = dayMoment.isSame(this.localdate, 'day');
//       const isToday = dayMoment.isSame(today, 'day');
//       const showday = this.pickpast || dayMoment.isSameOrAfter(today, 'day');

//       monthArray.push({
//         moment: dayMoment,
//         daydate: dayMoment.format('DD'),
//         dayOfWeekShort: this.dayNamesShort[dayMoment.day()],
//         dayOfWeekFull: this.dayNamesFull[dayMoment.day()],
//         showday: showday,
//         selected: isSelected,
//         isToday: isToday,
//         isBuffer: false
//       });
//     }
//     return monthArray;
//   }

//   // Adds buffer days to the beginning and end of the month array for smooth scrolling
//   private addBufferDays() {
//     const numVisibleCells = 7;
//     const bufferSize = Math.floor(numVisibleCells / 2);

//     const buffers: DayData[] = Array(bufferSize).fill(null).map(() => ({
//       moment: moment(), // Placeholder moment
//       daydate: '',
//       dayOfWeekShort: '',
//       dayOfWeekFull: '',
//       showday: false,
//       selected: false,
//       isToday: false,
//       isBuffer: true
//     }));

//     this.monthWithBuffers = [...buffers, ...this.month, ...buffers];
//   }

//   // Updates the 'selected' and 'isToday' properties in the monthWithBuffers array
//   private updateSelectedDateInMonth() {
//     const today = moment().startOf('day');
//     this.monthWithBuffers.forEach(day => {
//       day.selected = day.moment.isSame(this.localdate, 'day') && !day.isBuffer;
//       day.isToday = day.moment.isSame(today, 'day') && !day.isBuffer;
//     });
//   }

//   selectDate(day: DayData, index: number) {
//     if (!this.pickdate || !day.showday || day.isBuffer) { return; }

//     this.monthWithBuffers.forEach(d => d.selected = false);

//     this.localdate.date(day.moment.date())
//                    .month(day.moment.month())
//                    .year(day.moment.year());
//     day.selected = true;
//     this.selectedDay = this.localdate.format('dddd');

//     this.dateSelected.emit(this.localdate.clone());

//     // IMPORTANT: Re-parse slots AND then snap time for the newly selected date
//     this.parseAvailableTimeSlots();
//     this.snapLocaldateToNearestAvailableSlot();
//     this.updateTimelineVisualization();
//     this.currentTimeKey = this.determineTimeKey(this.localdate);

//     this.emitSelection();

//     this.scrollToIndex(index);
//   }

// moveBack() {
//   // If pickdate is not set, there's nothing to do.
//   if (!this.pickdate) return;

//   // Create a temporary moment object for the previous month to check against current date
//   const potentialNewViewDate = this.currentViewDate.clone().subtract(1, 'month');

//   // Get the current actual month and year
//   const today = moment();

//   // If the potential new view date is before the current month and year, do nothing.
//   // We use startOf('month') for comparison to ignore the day and time.
//   if (potentialNewViewDate.startOf('month').isBefore(today.startOf('month'))) {
//     console.log("Cannot go back before the current month.");
//     return; // Exit the function
//   }

//   // If we reach here, it's safe to move back a month
//   this.currentViewDate.subtract(1, 'month');

//   // Re-initialize and update selected date if it falls out of view
//   // If the current localdate's month is no longer the same as the new currentViewDate's month
//   if (!this.localdate.isSame(this.currentViewDate, 'month')) {
//     // Default to the same day in the new month, but ensure it doesn't exceed days in new month
//     this.localdate = this.currentViewDate.clone().date(Math.min(this.localdate.date(), this.currentViewDate.daysInMonth()));
//   }

//   this.parseAvailableTimeSlots(); // New month might have different slots
//   this.initializeDateTimeSelector(); // Re-initialize for new month
//   this.currentTimeKey = this.determineTimeKey(this.localdate); // Update theme
//   this.emitSelection(); // Emit the updated selection
//   this.scrollToSelectedDate(); // Scroll to the selected date
// }

//   moveForward() {
//     if (!this.pickdate) return;
//     this.currentViewDate.add(1, 'month');
//     // Re-initialize and update selected date if it falls out of view
//     const newMonthSelectedDate = this.localdate.clone().month(this.currentViewDate.month()).year(this.currentViewDate.year());
//     if (!newMonthSelectedDate.isSame(this.localdate, 'month')) {
//       this.localdate = this.currentViewDate.clone().date(Math.min(this.localdate.date(), this.currentViewDate.daysInMonth()));
//     }
//     this.parseAvailableTimeSlots(); // New month might have different slots
//     this.initializeDateTimeSelector(); // Re-initialize for new month
//     this.currentTimeKey = this.determineTimeKey(this.localdate);
//     this.emitSelection();
//     this.scrollToSelectedDate();
//   }

//   // --- Scrolling Logic for Date Slider ---
//   private scrollToSelectedDate() {
//     if (!this.dateScrollContainer || !this.dateScrollContainer.nativeElement) {
//       return;
//     }

//     const selectedIndex = this.monthWithBuffers.findIndex(day => day.selected);

//     if (selectedIndex !== -1) {
//       this.scrollToIndex(selectedIndex);
//     } else {
//         const todayIndex = this.monthWithBuffers.findIndex(day => day.isToday);
//         if (todayIndex !== -1) {
//             this.scrollToIndex(todayIndex);
//         } else {
//             const firstActualDayIndex = this.monthWithBuffers.findIndex(day => day.showday && !day.isBuffer);
//             if (firstActualDayIndex !== -1) {
//                 this.scrollToIndex(firstActualDayIndex);
//             }
//         }
//     }
//   }

//   private scrollToIndex(index: number) {
//     if (!this.dateScrollContainer || !this.dateScrollContainer.nativeElement) {
//       return;
//     }

//     const scrollContainer = this.dateScrollContainer.nativeElement;
//     const children = scrollContainer.children;

//     if (children.length === 0 || index < 0 || index >= children.length) {
//       return;
//     }

//     const targetElement = children[index] as HTMLElement;
//     const containerWidth = scrollContainer.offsetWidth;
//     const elementWidth = targetElement.offsetWidth;

//     const scrollLeft = targetElement.offsetLeft - (containerWidth / 2) + (elementWidth / 2);

//     scrollContainer.scrollTo({
//       left: scrollLeft,
//       behavior: 'smooth'
//     });
//   }

//   // --- Time Picker Methods ---

//   getHours(): number[] {
//     const hours = [];
//     for (let i = 0; i < 24; i++) {
//       hours.push(i);
//     }
//     return hours;
//   }

//   // Updated changetime method to take a key
//   changetime(key: string) {
//       this.currentTimeKey = key; // Update the selected key

//       // Find the first available slot for the selected key
//       const relevantSlots = this.availableTimeSlotsData?.data?.timeslots
//           .find(group => group.key === key)?.value || [];

//       if (relevantSlots.length > 0) {
//           const firstSlotMoment = moment(relevantSlots[0], "hh:mm A");
//           if (firstSlotMoment.isValid()) {
//               this.localdate.hours(firstSlotMoment.hours()).minutes(firstSlotMoment.minutes());
//           }
//       } else {
//           // Fallback if no slots for the key, maybe default to start of that "period"
//           if (key === 'Morning') {
//               this.localdate.hours(9).minutes(0);
//           } else if (key === 'Afternoon') {
//               this.localdate.hours(14).minutes(0);
//           } else if (key === 'Evening') {
//               this.localdate.hours(19).minutes(0);
//           } else {
//               // Default to current time if no key or no slots
//               this.localdate.hours(moment().hours()).minutes(moment().minutes());
//           }
//       }

//       this.snapLocaldateToNearestAvailableSlot();
//       this.time = this.formatTime(this.localdate);
//       this.timeframe = this.localdate.hours() >= 12 ? 'pm' : 'am';
//       this.updateInputTime();
//       this.updateTimelineVisualization();
//       this.emitSelection();
//   }


//   adjustTime(direction: 'increase' | 'decrease') {
//     let currentTotalMinutes = this.localdate.hours() * 60 + this.localdate.minutes();
//     let newTotalMinutes: number;
//     let dayChanged = false;

//     if (this.availableMinutes.length > 0) {
//         let currentIndex = this.availableMinutes.indexOf(currentTotalMinutes);
//         if (currentIndex === -1) {
//             // If current time is not an exact available slot, find the nearest one
//             const nearest = this.findNearestAvailableSlot(currentTotalMinutes);
//             currentIndex = this.availableMinutes.indexOf(nearest);
//             if (currentIndex === -1) currentIndex = 0; // Fallback if still not found
//         }

//         if (direction === 'increase') {
//             if (currentIndex < this.availableMinutes.length - 1) {
//                 newTotalMinutes = this.availableMinutes[currentIndex + 1];
//             } else {
//                 newTotalMinutes = this.availableMinutes[0]; // Wrap around to first slot of the day
//                 this.localdate.add(1, 'day');
//                 dayChanged = true;
//             }
//         } else { // 'decrease'
//             if (currentIndex > 0) {
//                 newTotalMinutes = this.availableMinutes[currentIndex - 1];
//             } else {
//                 newTotalMinutes = this.availableMinutes[this.availableMinutes.length - 1]; // Wrap around to last slot of the day
//                 this.localdate.subtract(1, 'day');
//                 dayChanged = true;
//             }
//         }
//     } else {
//         newTotalMinutes = currentTotalMinutes + (direction === 'increase' ? 30 : -30);
//         if (newTotalMinutes < 0) {
//             newTotalMinutes += this.totalMinutesInDay;
//             this.localdate.subtract(1, 'day');
//             dayChanged = true;
//         } else if (newTotalMinutes >= this.totalMinutesInDay) {
//             newTotalMinutes -= this.totalMinutesInDay;
//             this.localdate.add(1, 'day');
//             dayChanged = true;
//         }
//     }

//     this.localdate.hours(Math.floor(newTotalMinutes / 60)).minutes(newTotalMinutes % 60);
//     this.time = this.formatTime(this.localdate);
//     this.timeframe = this.localdate.hours() >= 12 ? 'pm' : 'am';
//     this.updateInputTime();
//     this.updateTimelineVisualization();
//     this.currentTimeKey = this.determineTimeKey(this.localdate);
//     this.emitSelection();

//     if (dayChanged) {
//       this.parseAvailableTimeSlots(); // Slots might change for a new day
//       this.initializeDateTimeSelector(); // Re-init calendar view
//       this.scrollToSelectedDate(); // Scroll to the new date
//     }
//   }

//   updateInputTime() {
//     this.edittime.formatted = this.localdate.format('hh:mm A');
//     this.edittime.input = this.edittime.formatted;
//   }

//   changeInputTime(event: KeyboardEvent) {
//     const input = (event.target as HTMLInputElement).value;
//     this.edittime.input = input;

//     const mTime = moment(input, "hh:mm A");

//     if (mTime.isValid()) {
//         let newTotalMinutes = mTime.hours() * 60 + mTime.minutes();
//         if (this.availableMinutes.length > 0) {
//             newTotalMinutes = this.findNearestAvailableSlot(newTotalMinutes);
//         }

//         // Check if date needs to change if time goes past midnight
//         const oldDay = this.localdate.dayOfYear();
//         this.localdate.hours(Math.floor(newTotalMinutes / 60)).minutes(newTotalMinutes % 60);
//         const newDay = this.localdate.dayOfYear();

//         if (oldDay !== newDay) {
//             this.parseAvailableTimeSlots(); // Re-parse slots for the new day
//             this.initializeDateTimeSelector(); // Re-init calendar view
//             this.scrollToSelectedDate(); // Scroll to new date
//         }

//         this.time = this.formatTime(this.localdate);
//         this.timeframe = this.localdate.hours() >= 12 ? 'pm' : 'am';
//         this.updateInputTime();
//         this.updateTimelineVisualization();
//         this.currentTimeKey = this.determineTimeKey(this.localdate);
//         this.emitSelection();
//     }
//   }

//   // --- Time Slider / Drag Logic ---

//   timeSelectStart(event: MouseEvent | TouchEvent) {
//     if (!this.picktime) return;

//     event.preventDefault();
//     event.stopPropagation();

//     const timeline = this.timelineElementRef.nativeElement;
//     const currentTimeElement = this.currentTimeElementRef.nativeElement;
//     if (!timeline || !currentTimeElement) {
//         console.warn('Timeline or current-time element reference not available.');
//         return;
//     }

//     const timelineRect = timeline.getBoundingClientRect();
//     this.timelineWidth = timelineRect.width;

//     const clientX = (event instanceof MouseEvent) ? event.clientX : event.touches[0].clientX;
//     const initialX = clientX - timelineRect.left;

//     this.updateCurrentTime(initialX);

//     this.ngZone.runOutsideAngular(() => {
//       const onMouseMove = (moveEvent: MouseEvent | TouchEvent) => {
//         const newClientX = (moveEvent instanceof MouseEvent) ? moveEvent.clientX : moveEvent.touches[0].clientX;
//         const newX = newClientX - timelineRect.left;
//         this.updateCurrentTime(newX);
//       };

//       const onMouseUp = (upEvent: MouseEvent | TouchEvent) => {
//         this.removeGlobalListeners();
//         this.ngZone.run(() => {
//             this.emitSelection(); // Emit final selection on drag end
//         });
//       };

//       this.removeGlobalListeners();

//       this.mouseMoveListener = this.renderer.listen('document', 'mousemove', onMouseMove);
//       this.mouseUpListener = this.renderer.listen('document', 'mouseup', onMouseUp);
//       this.touchMoveListener = this.renderer.listen('document', 'touchmove', onMouseMove);
//       this.touchEndListener = this.renderer.listen('document', 'touchend', onMouseUp);
//     });
//   }

//   private updateCurrentTime(xPos: number) {
//     let position = Math.max(0, Math.min(xPos, this.timelineWidth));
//     let targetMinutes = (position / this.timelineWidth) * this.totalMinutesInDay;

//     if (this.availableMinutes.length > 0) {
//       targetMinutes = this.findNearestAvailableSlot(targetMinutes);
//     } else {
//         targetMinutes = Math.round(targetMinutes / 5) * 5;
//     }

//     this.ngZone.run(() => {
//         const oldDay = this.localdate.dayOfYear();
//         this.localdate.hours(Math.floor(targetMinutes / 60)).minutes(targetMinutes % 60);
//         const newDay = this.localdate.dayOfYear();

//         if (oldDay !== newDay) {
//             // Day changed due to time adjustment, need to re-render date part
//             this.parseAvailableTimeSlots(); // Slots might change for a new day
//             this.initializeDateTimeSelector(); // Re-init calendar view
//             this.scrollToSelectedDate(); // Scroll to new date
//         }

//         this.time = this.formatTime(this.localdate);
//         this.timeframe = this.localdate.hours() >= 12 ? 'pm' : 'am';
//         this.updateInputTime();
//         this.currentTimeKey = this.determineTimeKey(this.localdate);

//         const currentTimeElement = this.currentTimeElementRef.nativeElement;
//         if (currentTimeElement) {
//             const snappedPosition = (targetMinutes / this.totalMinutesInDay) * this.timelineWidth;
//             this.renderer.setStyle(currentTimeElement, 'left', `${snappedPosition - (currentTimeElement.offsetWidth / 2)}px`);
//         }
//     });
//   }

//   // Finds the nearest available slot in `availableMinutes` to the `targetMinutes`
//   private findNearestAvailableSlot(targetMinutes: number): number {
//     if (this.availableMinutes.length === 0) {
//       return Math.round(targetMinutes / 5) * 5; // Fallback to 5-min intervals
//     }

//     let nearestSlot = this.availableMinutes[0];
//     let minDifference = Math.abs(targetMinutes - nearestSlot);

//     for (let i = 1; i < this.availableMinutes.length; i++) {
//       const slot = this.availableMinutes[i];
//       const difference = Math.abs(targetMinutes - slot);

//       if (difference < minDifference) {
//         minDifference = difference;
//         nearestSlot = slot;
//       }
//     }
//     return nearestSlot;
//   }

//   // Updates the visual markers on the timeline based on available slots
//   private updateTimelineVisualization() {
//       if (!this.timelineElementRef || !this.timelineElementRef.nativeElement || !this.picktime) {
//           return;
//       }

//       const timeline = this.timelineElementRef.nativeElement;
//       const existingSlotMarkers = timeline.querySelectorAll('.slot-marker');
//       existingSlotMarkers.forEach(marker => this.renderer.removeChild(timeline, marker));

//       const timelineRect = timeline.getBoundingClientRect();
//       this.timelineWidth = timelineRect.width;

//       this.availableMinutes.forEach(minutes => {
//           const position = (minutes / this.totalMinutesInDay) * this.timelineWidth;
//           const marker = this.renderer.createElement('div');
//           this.renderer.addClass(marker, 'slot-marker');
//           this.renderer.setStyle(marker, 'left', `${position}px`);
//           this.renderer.appendChild(timeline, marker);
//       });

//       // Position the current time indicator
//       this.updateCurrentTimePosition((this.localdate.hours() * 60 + this.localdate.minutes()) / this.totalMinutesInDay * this.timelineWidth);
//   }

//   // Positions the draggable circle (currentTimeElement) on the timeline
//   private updateCurrentTimePosition(targetX: number) {
//     if (this.currentTimeElementRef && this.currentTimeElementRef.nativeElement) {
//       const currentTimeElement = this.currentTimeElementRef.nativeElement;
//       this.renderer.setStyle(currentTimeElement, 'left', `${targetX - (currentTimeElement.offsetWidth / 2)}px`);
//     }
//   }

//   private removeGlobalListeners() {
//     if (this.mouseMoveListener) { this.mouseMoveListener(); this.mouseMoveListener = null; }
//     if (this.mouseUpListener) { this.mouseUpListener(); this.mouseUpListener = null; }
//     if (this.touchMoveListener) { this.touchMoveListener(); this.touchMoveListener = null; }
//     if (this.touchEndListener) { this.touchEndListener(); this.touchEndListener = null; }
//   }

//   // --- New: Parse and Store Available Time Slots ---
//   private parseAvailableTimeSlots() {
//     this.availableMinutes = [];
//     this.availableKeys = []; // Reset keys

//     if (this.availableTimeSlotsData && this.availableTimeSlotsData.data && this.availableTimeSlotsData.data.timeslots) {
//       this.availableTimeSlotsData.data.timeslots.forEach(group => {
//         this.availableKeys.push(group.key); // Store the key
//         group.value.forEach(timeStr => {
//           const mTime = moment(timeStr, "hh:mm A");
//           if (mTime.isValid()) {
//             this.availableMinutes.push(mTime.hours() * 60 + mTime.minutes());
//           }
//         });
//       });
//       this.availableMinutes.sort((a, b) => a - b);
//       // Ensure unique keys and maintain order if needed
//       this.availableKeys = Array.from(new Set(this.availableKeys));
//       // console.log('Parsed Available Minutes:', this.availableMinutes);
//       // console.log('Parsed Available Keys:', this.availableKeys);
//     } else {
//         // console.log('No available slots data provided or invalid structure.');
//     }
//   }

//   private snapLocaldateToNearestAvailableSlot() {
//     if (this.picktime && this.availableMinutes.length > 0) {
//         const currentMinutes = this.localdate.hours() * 60 + this.localdate.minutes();
//         const snappedMinutes = this.findNearestAvailableSlot(currentMinutes);
//         this.localdate.hours(Math.floor(snappedMinutes / 60)).minutes(snappedMinutes % 60);
//         if (this.timelineElementRef && this.timelineElementRef.nativeElement) {
//             const timelineRect = this.timelineElementRef.nativeElement.getBoundingClientRect();
//             this.timelineWidth = timelineRect.width;
//             const targetX = (snappedMinutes / this.totalMinutesInDay) * this.timelineWidth;
//             this.updateCurrentTimePosition(targetX);
//         }
//     } else if (this.picktime) {
//         // If no available slots, still snap to 30-min intervals as a default
//         const minutes = this.localdate.minutes();
//         this.localdate.minutes(Math.round(minutes / 30) * 30);
//     }
//   }

//   // Finds the original string representation of the selected time slot from the API data
//   private findMatchingTimeSlotString(): string {
//     if (!this.availableTimeSlotsData?.data?.timeslots) {
//       return ''; // No data to search
//     }

//     const targetHour = this.localdate.hours();
//     const targetMinute = this.localdate.minutes();

//     for (const group of this.availableTimeSlotsData.data.timeslots) {
//       for (const timeStr of group.value) {
//         const mTime = moment(timeStr, "hh:mm A");
//         if (mTime.isValid() && mTime.hours() === targetHour && mTime.minutes() === targetMinute) {
//           return timeStr; // Return the exact string from the API
//         }
//       }
//     }
//     // Fallback: If no exact slot string is found (e.g., custom typed time), format it
//     return this.localdate.format('hh:mm A');
//   }

//   // Determines the time key (Morning, Afternoon, Evening) based on current time
//   private determineTimeKey(m: moment.Moment): string {
//     if (!this.availableTimeSlotsData?.data?.timeslots || this.availableTimeSlotsData.data.timeslots.length === 0) {
//       // Fallback to general AM/PM if no specific timeslot data is provided
//       return m.hours() < 12 ? 'AM' : 'PM';
//     }

//     const currentMinutes = m.hours() * 60 + m.minutes();

//     // Iterate through provided time slot groups
//     for (const group of this.availableTimeSlotsData.data.timeslots) {
//         // Find the slot in this group that is closest to or matches the current time
//         const closestSlotInGroup = group.value
//             .map(timeStr => moment(timeStr, "hh:mm A"))
//             .filter(m => m.isValid())
//             .map(m => m.hours() * 60 + m.minutes())
//             .reduce((prev, curr) => {
//                 return (Math.abs(curr - currentMinutes) < Math.abs(prev - currentMinutes) ? curr : prev);
//             }, group.value.length > 0 ? moment(group.value[0], "hh:mm A").hours() * 60 + moment(group.value[0], "hh:mm A").minutes() : -1); // Initialize with first slot's minutes or -1

//         // If the current time matches (or is very close to) a slot in this group, return its key
//         // We can define a small threshold, e.g., 5 minutes, if perfect match isn't expected
//         if (Math.abs(closestSlotInGroup - currentMinutes) <= 5) { // 5 minute threshold for matching
//             return group.key;
//         }
//     }

//     // Fallback if no specific group matches well, use general time ranges
//     // This is useful if the API keys don't perfectly cover all time ranges
//     if (m.hours() >= 0 && m.hours() < 12) {
//         return 'Morning';
//     } else if (m.hours() >= 12 && m.hours() < 17) {
//         return 'Afternoon';
//     } else if (m.hours() >= 17 && m.hours() <= 23) {
//         return 'Evening';
//     }

//     return '';
//   }

//   // --- Utility Methods ---

//   checkWidth() {
//     this.compact = this.platform.width() < 620;
//     this.updateTimelineVisualization();
//   }

//   formatTime(m: moment.Moment): string {
//     return m.format('hh:mm A');
//   }

//   trackByFn(index: number, item: DayData): any {
//     return item.isBuffer ? `buffer-${index}` : item.moment.valueOf();
//   }
// }

import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, NgZone, AfterViewInit, ViewChild, ElementRef, Renderer2, SimpleChanges, OnChanges } from '@angular/core';
import { Platform } from '@ionic/angular';
import * as moment from 'moment';

// Define the interface for your API response data
interface TimeSlotGroup {
  key: string;
  value: string[]; // e.g., ["10:00 AM", "10:15 AM"]
}

interface ApiResponse {
  success: boolean;
  code: number;
  message: string;
  data: {
    timeslots: TimeSlotGroup[];
  };
}

// New interface for enriched day data including buffer properties
interface DayData {
  moment: moment.Moment;
  daydate: string; // e.g., '25'
  dayOfWeekShort: string; // e.g., 'Mon'
  dayOfWeekFull: string; // e.g., 'Monday'
  showday: boolean; // Is it part of the actual month, or a filler?
  selected: boolean; // Is this day currently selected?
  isToday: boolean; // Is this day today's date?
  isBuffer?: boolean; // New: Is this an empty buffer day for scrolling?
}

@Component({
  selector: 'test-item',
  templateUrl: './test-item.component.html',
  styleUrls: ['./test-item.component.scss'],
})
export class TestItemComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  // --- @Inputs() ---
  @Input('datepicker-title') datepickerTitle: string = 'Select Date';
  @Input('custom-message') customMessage: string = 'You have selected';
  @Input() selecteddate: moment.Moment = moment();
  @Input('picktime') picktime: boolean = true;
  @Input('pickdate') pickdate: boolean = true;
  @Input('pickpast') pickpast: boolean = false;
  @Input('mondayfirst') mondayfirst: boolean = false;
  @Input() appLanguage: string = 'en';

  @Input('available-time-slots-data') availableTimeSlotsData: ApiResponse | null = null;

  // --- @Output() ---
  @Output() updatefn = new EventEmitter<{ formattedDate: string, selectedSlot: string, selectedKey: string }>();
  @Output() dateSelected = new EventEmitter<moment.Moment>();

  // --- View Children ---
  @ViewChild('dateScrollContainer', { static: false }) dateScrollContainer!: ElementRef<HTMLElement>;

  // --- Internal Component State ---
  currentTimeKey: string = '';
  monthNames: string[] = moment.months();
  dayNamesFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  dayNamesShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  currentViewDate: moment.Moment;
  localdate: moment.Moment;
  selectedDay: string = '';

  month: DayData[] = [];
  monthWithBuffers: DayData[] = [];

  compact: boolean = true;

  time: string = '';

  availableKeys: string[] = [];
  selectedCategorySlots: string[] = [];

  constructor(
    private platform: Platform,
    private ngZone: NgZone,
    private renderer: Renderer2
  ) {
    this.localdate = moment();
    this.currentViewDate = this.localdate.clone().startOf('month');
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  ngOnInit() {
    this.picktime = String(this.picktime) === 'true';
    this.pickdate = String(this.pickdate) === 'true';
    this.pickpast = String(this.pickpast) === 'true';
    this.mondayfirst = String(this.mondayfirst) === 'true';

    if (this.selecteddate && moment.isMoment(this.selecteddate) && this.selecteddate.isValid()) {
      this.localdate = this.selecteddate.clone();
    } else {
      this.localdate = moment();
    }

    this.parseAvailableTimeSlots();
    this.initializeDateTimeSelector();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selecteddate']) {
        const newMomentValue = changes['selecteddate'].currentValue;
        let newDateMoment: moment.Moment;
        if (moment.isMoment(newMomentValue) && newMomentValue.isValid()) {
            newDateMoment = newMomentValue.clone();
        } else if (typeof newMomentValue === 'string' && moment(newMomentValue).isValid()) {
            newDateMoment = moment(newMomentValue);
        } else {
            console.warn('Invalid moment object or string received for selecteddate input (ngOnChanges):', newMomentValue);
            newDateMoment = moment();
        }

        if (!this.localdate || !newDateMoment.isSame(this.localdate, 'day')) {
            const currentHours = this.localdate.hours();
            const currentMinutes = this.localdate.minutes();
            this.localdate = newDateMoment.clone().hours(currentHours).minutes(currentMinutes);
            
            this.currentViewDate = newDateMoment.clone().startOf('month');
            this.parseAvailableTimeSlots();
            this.initializeDateTimeSelector();
            this.emitSelection();
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => this.scrollToSelectedDate(), 0);
            });
        }
    }

    if (changes['availableTimeSlotsData'] && changes['availableTimeSlotsData'].currentValue !== changes['availableTimeSlotsData'].previousValue) {
      this.availableTimeSlotsData = changes['availableTimeSlotsData'].currentValue;
      this.parseAvailableTimeSlots();
      this.initializeDateTimeSelector();
      this.emitSelection();
    }
  }

  ngAfterViewInit() {
    this.checkWidth();
    this.platform.resize.subscribe(() => {
      this.ngZone.run(() => {
        this.checkWidth();
      });
    });

    if (this.availableTimeSlotsData && this.availableKeys.length === 0) {
      this.parseAvailableTimeSlots();
      this.initializeDateTimeSelector();
    }

    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.scrollToSelectedDate();
      }, 0);
    });
  }

  ngOnDestroy() {
    // No global listeners for time slider anymore
  }

  // --- Core Initialization and State Management ---

  private emitSelection() {
    const formattedDateString = this.localdate.format('YYYY-MM-DD');
    this.updatefn.emit({
      formattedDate: formattedDateString,
      selectedSlot: this.time,
      selectedKey: this.currentTimeKey
    });
  }

  initializeDateTimeSelector() {
    this.month = this.getDaysArrayByMonth(this.currentViewDate);
    this.addBufferDays();
    this.updateSelectedDateInMonth();

    this.selectedDay = this.localdate.format('dddd');

    if (this.picktime) {
        const initialCategory = this.determineTimeKey(this.localdate);
        
        if (this.availableKeys.includes(initialCategory)) {
            this.selectTimeCategory(initialCategory);
        } else if (this.availableKeys.length > 0) {
            this.selectTimeCategory(this.availableKeys[0]);
        } else {
            this.currentTimeKey = '';
            this.selectedCategorySlots = [];
            this.time = '';
        }

        if (!this.time && this.selectedCategorySlots.length > 0) {
            this.selectSpecificTime(this.selectedCategorySlots[0]);
        } else if (this.time && !this.selectedCategorySlots.includes(this.time)) {
             this.snapLocaldateToNearestAvailableSlot();
        } else if (this.selectedCategorySlots.length > 0) {
            const selectedSlotMoment = moment(this.time, "hh:mm A");
            if (selectedSlotMoment.isValid()) {
                 this.localdate.hours(selectedSlotMoment.hours()).minutes(selectedSlotMoment.minutes());
            }
        } else {
            this.time = '';
        }
    }
    this.emitSelection();
  }

  // --- Date Picker (Slider) Methods ---

  currentMonthName(): string {
    return this.currentViewDate.format('MMMM');
  }

  private getDaysArrayByMonth(date: moment.Moment): DayData[] {
    const numDaysInMonth = date.daysInMonth();
    const monthArray: DayData[] = [];
    const today = moment().startOf('day');

    const firstDayMoment = date.clone().startOf('month');
    let firstDayOfMonthIndex = firstDayMoment.day();

    if (this.mondayfirst) {
        firstDayOfMonthIndex = (firstDayOfMonthIndex === 0) ? 6 : firstDayOfMonthIndex - 1;
    }

    for (let i = 1; i <= numDaysInMonth; i++) {
      const dayMoment = date.clone().date(i).startOf('day');
      const isSelected = dayMoment.isSame(this.localdate, 'day');
      const isToday = dayMoment.isSame(today, 'day');
      const showday = this.pickpast || dayMoment.isSameOrAfter(today, 'day');

      monthArray.push({
        moment: dayMoment,
        daydate: dayMoment.format('DD'),
        dayOfWeekShort: this.dayNamesShort[dayMoment.day()],
        dayOfWeekFull: this.dayNamesFull[dayMoment.day()],
        showday: showday,
        selected: isSelected,
        isToday: isToday,
        isBuffer: false
      });
    }
    return monthArray;
  }

  private addBufferDays() {
    const numVisibleCells = 7;
    const bufferSize = Math.floor(numVisibleCells / 2);

    const buffers: DayData[] = Array(bufferSize).fill(null).map(() => ({
      moment: moment(),
      daydate: '',
      dayOfWeekShort: '',
      dayOfWeekFull: '',
      showday: false,
      selected: false,
      isToday: false,
      isBuffer: true
    }));

    this.monthWithBuffers = [...buffers, ...this.month, ...buffers];
  }

  private updateSelectedDateInMonth() {
    const today = moment().startOf('day');
    this.monthWithBuffers.forEach(day => {
      day.selected = day.moment.isSame(this.localdate, 'day') && !day.isBuffer;
      day.isToday = day.moment.isSame(today, 'day') && !day.isBuffer;
    });
  }

  selectDate(day: DayData, index: number) {
    if (!this.pickdate || !day.showday || day.isBuffer) { return; }

    this.monthWithBuffers.forEach(d => d.selected = false);

    const currentHours = this.localdate.hours();
    const currentMinutes = this.localdate.minutes();
    this.localdate.date(day.moment.date())
                   .month(day.moment.month())
                   .year(day.moment.year())
                   .hours(currentHours)
                   .minutes(currentMinutes);

    day.selected = true;
    this.selectedDay = this.localdate.format('dddd');

    this.dateSelected.emit(this.localdate.clone());

    this.parseAvailableTimeSlots();
    this.initializeDateTimeSelector();

    this.emitSelection();
    this.scrollToIndex(index);
  }

  moveBack() {
    if (!this.pickdate) return;

    const potentialNewViewDate = this.currentViewDate.clone().subtract(1, 'month');
    const today = moment();

    if (!this.pickpast && potentialNewViewDate.startOf('month').isBefore(today.startOf('month'))) {
      console.log("Cannot go back before the current month.");
      return;
    }

    this.currentViewDate.subtract(1, 'month');

    if (!this.localdate.isSame(this.currentViewDate, 'month')) {
      this.localdate = this.currentViewDate.clone().date(Math.min(this.localdate.date(), this.currentViewDate.daysInMonth()));
    }
    this.parseAvailableTimeSlots();
    this.initializeDateTimeSelector();
    this.emitSelection();
    this.scrollToSelectedDate();
  }

  moveForward() {
    if (!this.pickdate) return;
    this.currentViewDate.add(1, 'month');
    const newMonthSelectedDate = this.localdate.clone().month(this.currentViewDate.month()).year(this.currentViewDate.year());
    if (!newMonthSelectedDate.isSame(this.localdate, 'month')) {
      this.localdate = this.currentViewDate.clone().date(Math.min(this.localdate.date(), this.currentViewDate.daysInMonth()));
    }
    this.parseAvailableTimeSlots();
    this.initializeDateTimeSelector();
    this.emitSelection();
    this.scrollToSelectedDate();
  }

  // --- Scrolling Logic for Date Slider ---
  private scrollToSelectedDate() {
    if (!this.dateScrollContainer || !this.dateScrollContainer.nativeElement) {
      return;
    }

    const selectedIndex = this.monthWithBuffers.findIndex(day => day.selected);

    if (selectedIndex !== -1) {
      this.scrollToIndex(selectedIndex);
    } else {
        const todayIndex = this.monthWithBuffers.findIndex(day => day.isToday);
        if (todayIndex !== -1) {
            this.scrollToIndex(todayIndex);
        } else {
            const firstActualDayIndex = this.monthWithBuffers.findIndex(day => day.showday && !day.isBuffer);
            if (firstActualDayIndex !== -1) {
                this.scrollToIndex(firstActualDayIndex);
            }
        }
    }
  }

  private scrollToIndex(index: number) {
    if (!this.dateScrollContainer || !this.dateScrollContainer.nativeElement) {
      return;
    }

    const scrollContainer = this.dateScrollContainer.nativeElement;
    const children = scrollContainer.querySelectorAll('.date-cell'); 

    if (children.length === 0 || index < 0 || index >= children.length) {
      return;
    }

    const targetElement = children[index] as HTMLElement;
    const containerWidth = scrollContainer.offsetWidth;
    const elementWidth = targetElement.offsetWidth;

    const scrollLeft = targetElement.offsetLeft - (containerWidth / 2) + (elementWidth / 2);

    scrollContainer.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }

  // --- Time Picker Logic (Button-based) ---

  selectTimeCategory(key: string) {
    if (!this.picktime || !this.availableKeys.includes(key)) { return; }

    this.currentTimeKey = key;
    this.selectedCategorySlots = [];

    const timeGroup = this.availableTimeSlotsData?.data?.timeslots.find(group => group.key === key);

    if (timeGroup && timeGroup.value.length > 0) {
      this.selectedCategorySlots = timeGroup.value;
      
      const currentSelectedSlotExistsInNewCategory = this.selectedCategorySlots.includes(this.time);
      
      if (currentSelectedSlotExistsInNewCategory) {
          // Time already selected and is in this category, do nothing
      } else {
          this.selectSpecificTime(this.selectedCategorySlots[0]);
      }
    } else {
      this.selectedCategorySlots = [];
      this.time = '';
      this.localdate.hours(0).minutes(0);
    }
    this.emitSelection();
  }

  selectSpecificTime(slot: string) {
    if (!this.picktime || !slot) { return; }

    const selectedMoment = moment(slot, "hh:mm A");
    if (selectedMoment.isValid()) {
      this.localdate.hours(selectedMoment.hours()).minutes(selectedMoment.minutes());
      this.time = slot;
    } else {
      console.warn('Invalid time slot string selected:', slot);
      this.time = '';
      this.localdate.hours(0).minutes(0);
    }
    this.emitSelection();
  }

  private determineTimeKey(m: moment.Moment): string {
    const hour = m.hours();
    if (hour >= 6 && hour < 12) {
      return 'Morning';
    } else if (hour >= 12 && hour < 18) {
      return 'Afternoon';
    } else if (hour >= 18 || hour < 6) {
      return 'Evening';
    }
    return this.availableKeys.length > 0 ? this.availableKeys[0] : '';
  }

  private formatTime(m: moment.Moment): string {
    return m.format('hh:mm A');
  }

  // --- Utility Methods (Revised/Retained) ---

  private findNearestAvailableSlot(targetMinutes: number, availableSlotStrings?: string[]): number {
    let slotsToSearch: number[] = [];

    if (availableSlotStrings && availableSlotStrings.length > 0) {
      slotsToSearch = availableSlotStrings.map(timeStr => {
        const mTime = moment(timeStr, "hh:mm A");
        return mTime.isValid() ? (mTime.hours() * 60 + mTime.minutes()) : -1;
      }).filter(minutes => minutes !== -1);
    } else {
      // REPLACED flatMap with reduce and concat for ES5/ES6 compatibility
      if (this.availableTimeSlotsData && this.availableTimeSlotsData.data && this.availableTimeSlotsData.data.timeslots) {
        slotsToSearch = this.availableTimeSlotsData.data.timeslots.reduce((acc: number[], group: TimeSlotGroup) => {
          const groupMinutes = group.value.map(timeStr => {
            const mTime = moment(timeStr, "hh:mm A");
            return mTime.isValid() ? (mTime.hours() * 60 + mTime.minutes()) : -1;
          }).filter(minutes => minutes !== -1);
          return acc.concat(groupMinutes);
        }, []);
        slotsToSearch.sort((a, b) => a - b); // Ensure sorted after flattening
      }
    }
    
    if (slotsToSearch.length === 0) {
      return Math.round(targetMinutes / 5) * 5; 
    }

    let nearestSlot = slotsToSearch[0];
    let minDifference = Math.abs(targetMinutes - nearestSlot);

    for (let i = 1; i < slotsToSearch.length; i++) {
      const slot = slotsToSearch[i];
      const difference = Math.abs(targetMinutes - slot);

      if (difference < minDifference) {
        minDifference = difference;
        nearestSlot = slot;
      } else if (difference === minDifference) {
        if (slot > nearestSlot) {
            nearestSlot = slot;
        }
      }
    }
    return nearestSlot;
  }

  private parseAvailableTimeSlots() {
    this.availableKeys = [];

    if (this.availableTimeSlotsData && this.availableTimeSlotsData.data && this.availableTimeSlotsData.data.timeslots) {
      this.availableKeys = Array.from(new Set(this.availableTimeSlotsData.data.timeslots.map(group => group.key)));
      this.availableKeys.sort((a, b) => {
          const order = ['Morning', 'Afternoon', 'Evening', 'Night'];
          return order.indexOf(a) - order.indexOf(b);
      });
    } else {
        this.availableKeys = [];
        this.currentTimeKey = '';
        this.selectedCategorySlots = [];
        this.time = '';
    }
  }

  private snapLocaldateToNearestAvailableSlot() {
    if (this.picktime && this.selectedCategorySlots.length > 0) {
        const currentMinutes = this.localdate.hours() * 60 + this.localdate.minutes();
        const snappedMinutes = this.findNearestAvailableSlot(currentMinutes, this.selectedCategorySlots);
        this.localdate.hours(Math.floor(snappedMinutes / 60)).minutes(snappedMinutes % 60);
        this.time = this.formatTime(this.localdate);
    } else if (this.picktime && this.availableKeys.length > 0) {
        this.selectTimeCategory(this.availableKeys[0]);
    } else {
      this.time = '';
      this.localdate.hours(0).minutes(0);
    }
  }

  private checkWidth() {
    // Implementation for compact mode based on width
  }
}